import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  sales_returns: [],
};

const getters = {
  allSalesReturns: (state) => state.sales_returns,
};

const actions = {
  async fetchSalesReturns({ commit }, params = {}) {
    try {
      commit("resetSalesReturns");
      const response = await axios.get("/sales-return", { params: prm(params) });
      commit("setSalesReturns", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch sales_returns:", error);
    }
  },
  async createSalesReturn({ commit }, sales_return) {
    try {
      const response = await axios.post("/sales-return", sales_return);
      commit("addSalesReturn", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create sales_return:", error);
      throw error;
    }
  },
  async fetchSalesReturnById(_, id) {
    try {
      const response = await axios.get(`/sales-return/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch sales_return:", error);
      throw error;
    }
  },
  async updateSalesReturn({ commit }, sales_return) {
    try {
      const response = await axios.put(`/sales-return/${sales_return.id}`, sales_return);
      commit("updateSalesReturn", response.data);
    } catch (error) {
      console.error("Failed to update sales_return:", error);
      throw error;
    }
  },
  async closeSalesReturn({ commit }, sales_return) {
    try {
      const response = await axios.post(`/sales-return/close`, sales_return);
      commit("closeSalesReturn", response.data);
    } catch (error) {
      console.error("Failed to close sales_return:", error);
      throw error;
    }
  },
  async deleteSalesReturnById({ commit }, id) {
    try {
      const response = await axios.delete(`/sales-return/${id}`);
      commit("removeSalesReturn", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete sales_return:", error);
      throw error;
    }
  },
};

const mutations = {
  setSalesReturns(state, sales_returns) {
    state.sales_returns = sales_returns.data; // Ensure this matches your API's response structure
  },
  addSalesReturn(state, sales_return) {
    state.sales_returns.push(sales_return);
  },
  updateSalesReturn(state, updatedSalesReturn) {
    const index = state.sales_returns.findIndex(
      (sales_return) => sales_return.id === updatedSalesReturn.id
    );
    if (index !== -1) {
      state.sales_returns.splice(index, 1, updatedSalesReturn);
    }
  },
  removeSalesReturn(state, id) {
    state.sales_returns = state.sales_returns.filter(
      (sales_return) => sales_return.id !== id
    );
  },
  resetSalesReturns(state) {
    state.sales_returns = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
